import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const arrow_down_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        fillRule="evenodd"
        stroke={iconColor}
        strokeWidth={"1"}
        d="M11.5,5 L11.5,17.5 M7.5,13.5 L11.5,17.5 L15.5,13.5"
      />
    </svg>
  );
};
